// @flow
import React, { Component, type Node } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'

type State = {
  hasError: boolean
}

export class ErrorBoundary extends Component<{ children: Node }, State> {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.log(error)
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className='ui error icon message'>
          <i className='warning circle icon' />
          <div className='content'>
            <div className='header'>Ein Fehler ist aufgetreten</div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
